//var baseUrl = "http://127.0.0.1:18077";//dev
var baseUrl = "http://47.94.85.250:18077";//test
export function getVideoUrl() {
    return baseUrl+"/index/video";
}
export function getNewUrl() {
    return baseUrl+"/new/list";
}
export function getFaqUrl() {
    return baseUrl+"/faq/list";
}
export function getGuideUrl() {
    return baseUrl+"/guide/content";
}
export function getWayUrl() {
    return baseUrl+"/way/content";
}
export function getApplyUrl() {
    return baseUrl+"/apply/save";
}